import { SetGameStatus } from "./types";

export function onStarted(setGameStatus: SetGameStatus) {
  setGameStatus("playing");
}
